/* WHITELIGGHT111 — scroll reveal
   IntersectionObserver-gated, transform/opacity only, no library.
   Respects prefers-reduced-motion and degrades to fully-visible content. */
(function () {
  "use strict";

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
  var nodes = document.querySelectorAll(".wl-reveal");
  if (!nodes.length) return;

  if (reduce.matches || !("IntersectionObserver" in window)) {
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add("is-in");
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        // Stagger siblings within a group by <= 60ms (§33.4).
        var group = el.closest("[data-wl-reveal-group]");
        var delay = 0;
        if (group) {
          var items = group.querySelectorAll(".wl-reveal");
          var idx = Array.prototype.indexOf.call(items, el);
          delay = Math.min(idx, 4) * 55;
        }
        el.style.setProperty("--wl-reveal-delay", delay + "ms");
        el.classList.add("is-in");
        observer.unobserve(el);
      });
    },
    { rootMargin: "0px 0px -12% 0px", threshold: 0.12 }
  );

  for (var j = 0; j < nodes.length; j++) observer.observe(nodes[j]);
})();
